import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "select-buttons flex flex-wrap list-none text-sm pl-0 font-bold" }
const _hoisted_2 = ["onClick"]

interface selectButtonProps {
  items: Item[];
  selectedItem: string | number;
}
interface Item {
  id: string | number;
  label: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AppSelectButton',
  props: {
    items: {},
    selectedItem: {}
  },
  emits: ["selectItem"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const selectItem = (item: Item) => {
  emit('selectItem', item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.id,
        class: _normalizeClass([{ selected: __props.selectedItem === item.id }, "mr-2 mb-2 flex align-items-center border-round-md cursor-pointer text-color-secondary"]),
        onClick: ($event: any) => (selectItem(item))
      }, [
        _createElementVNode("span", null, _toDisplayString(item.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})